import { useEffect, useState } from 'react';

/**
 * Ensures the Drawer open animation plays properly at the first render
 */
export const useDelayedDrawerOpen = (container: HTMLElement | null, open: boolean) => {
  const [isReady, setIsReady] = useState(false);
  const [delayedOpen, setDelayedOpen] = useState(false);

  useEffect(() => {
    if (container) {
      setIsReady(true);
    }
  }, [container]);

  useEffect(() => {
    if (isReady) {
      requestAnimationFrame(() => {
        setDelayedOpen(open);
      });
    }
  }, [isReady, open]);

  return {
    delayedOpen,
    isReady,
  };
};
